<template>
  <div class="input-message"  :class="{'botter-disabled': $store.state.chatHistory.sessionBotStatus}">
    <v-form @submit.prevent="sendMessage">
      <v-text-field
        height="50"
        :disabled="$store.state.chatHistory.sessionBotStatus"
        placeholder="Send message"
        v-model="input"
        outline
      />
    </v-form>
    <div class="messages-actions">
      <input-blocks @sendBlock="sendBlock"/>
      <input-attachment @sendAttachment="sendAttachment"/>
      <emoji @sendText="input += $event" ref="emojiCom"/>
    </div>
  </div>
</template>

<script>
  import inputAttachment from "./inputAttachment";
  import emoji from "./emoji";
  import inputBlocks from "./inputBlocks";
  export default {
    name: "messageInput",
    components: {
      inputAttachment,
      emoji,
      inputBlocks
    },
    props: {
      selectedSession: {
        type: Object,
        default: ()=>{
          return {}
        }
      }
    },
    data() {
      return {
        input: '',
      }
    },
    methods: {
      sendMessage() {
        this.$http_chat.post(`/sessions/${this.selectedSession._id}/reply`,{
          message: this.input,
          type: 'text'
        })
        .then(res=>{
          this.$emit('pushMessage',{
            slug: 'text',
            payload: this.input,
            created_at: new Date().toISOString(),
            sender:{
              sender_type: 'BOT'
            }
          })
          this.$refs.emojiCom.emojiDialog = false
          this.input = ''
        })
        .catch(err=>{
          console.log(err.response)
          this.$store.dispatch('setSnackbar',
            {
              text: err.response.data.message.error,
              color: 'error',
              status: true
            }
          )
          this.$refs.emojiCom.emojiDialog = false
        })
      },
      sendAttachment(data) {
        this.$http_chat.post(`/sessions/${this.selectedSession._id}/reply`,{
          url: data.url,
          type: 'attachment',
          attachment_type: data.type,
          file_name: data.name
        })
          .then(response=>{
            this.$emit('pushMessage',{
              slug: data.type,
              mediaUrl: data.url,
              fileName: data.name,
              created_at: new Date().toISOString(),
              sender:{
                sender_type: 'BOT'
              }
            })
            this.$store.dispatch('setLoader', false)
          })
          .catch(err=>{
            this.$store.dispatch('setLoader', false)
            this.$store.dispatch('setSnackbar',
              {
                text: err.response.data.message.error,
                color: 'error',
                status: true
              }
            )
          })
      },
      sendBlock(block) {
        this.$http_chat.post(`/sessions/${this.selectedSession._id}/reply`,{
          block_id: `block_id:{${block.id}}`,
          type: 'block'
        })
          .then(res=> {
            this.$store.dispatch('setLoader',true)
            setTimeout(()=> {
              this.$emit('sendBlock')
            },1000)
          })
          .catch(err=>{
            this.$store.dispatch('setSnackbar',
              {
                text: err.response.data.message.error,
                color: 'error',
                status: true
              }
            )
          })
      }
    }
  }
</script>

<style lang="scss">
.input-message {
  position: relative;
  height: 50px;
  display: flex;
  align-items: center;
  margin: 15px 20px ;
  border-radius: 8px;
  border: 1px solid #e2e2ea;
  justify-content: space-between;
  .v-form {
    width: 85%;
    .v-text-field.v-text-field--enclosed .v-text-field__details {
      display: none;
    }
    .v-input input {
      max-height: 40px !important;
    }
    .v-text-field--outline .v-input__control > .v-input__slot {
      background-color: white !important;
      height: 40px !important;
    }
  }
  .messages-actions {
    padding-right: 20px;
    display: flex;
    align-items: center;
    .action-icon {
      display: flex;
      align-items: center;
      color: #aaaaaa;
      font-size: 16px;
      cursor: pointer;
      margin: 0 8px;
    }
  }
}
</style>
